import { callbackFn, loadAppxBridge } from "../utils";
export default (function () {
  var callMap = {};
  var WAITING_QUEUE = [];
  var isListening = false;
  function onMessage() {
    var env = window;
    var messageHandler = env.my.onMessage;
    env.my.onMessage = function (message) {
      var serialId = message.serialId;
      var data = message.result;
      if (serialId) {
        var callback = callMap[serialId];
        callbackFn(data, callback);
        delete callMap[serialId];
      } else if (messageHandler) {
        messageHandler(message);
      }
    };
  }
  function fireMessage(_a) {
    var apiName = _a.apiName,
      options = _a.options,
      isSync = _a.isSync;
    var env = window;
    var random = Math.floor(Math.random() * 1000000);
    var serialId = apiName + '_' + random;
    if (options) {
      callMap[serialId] = options;
    }
    var params = {
      type: 'apiCall',
      api: apiName,
      serialId: serialId,
      options: options,
      isSync: isSync
    };
    env.my.postMessage(params);
  }
  return function call(apiName, options, isSync) {
    loadAppxBridge(function (bridgeReady) {
      var params = {
        apiName: apiName,
        options: options,
        isSync: isSync
      };
      if (bridgeReady) {
        if (!isListening) {
          onMessage();
          isListening = true;
        }
        if (WAITING_QUEUE.length) {
          WAITING_QUEUE.forEach(fireMessage);
          WAITING_QUEUE = [];
        }
        fireMessage(params);
      } else {
        WAITING_QUEUE.push(params);
      }
    });
  };
})();